import {
    DataRecordValue,
    DataRecord,
    getMetricLabel,
    getColumnLabel,
} from '@superset-ui/core';
import { EChartsCoreOption, GaugeSeriesOption, number } from 'echarts';
import {
    DEFAULT_FORM_DATA as DEFAULT_CHART_FORM_DATA,
    EchartsGaugeChartProps,
    EchartsGaugeFormData,
    GaugeChartTransformedProps,
} from './types';
import { DEFAULT_LEGEND_FORM_DATA } from '../../../types';
import {
    extractGroupbyLabel,
} from '../../../utils/series';
  
export default function transformProps(
    chartProps: EchartsGaugeChartProps,
): GaugeChartTransformedProps {
    const { formData, height, hooks, queriesData, width } =
      chartProps;
    const data: DataRecord[] = queriesData[0].data || [];
  
    const {
      groupby,
      metric = '',
      tooltipFormat,
      showLegend,
      showLabels
    }: EchartsGaugeFormData = {
      ...DEFAULT_LEGEND_FORM_DATA,
      ...DEFAULT_CHART_FORM_DATA,
      ...formData,
    };
    const metricLabel = getMetricLabel(metric);
    const groupbyLabels = Array.isArray(groupby) ? groupby.map(getColumnLabel)
      : [groupby].map(getColumnLabel);

    const labelMap = data.reduce(
      (acc: Record<string, DataRecordValue[]>, datum) => {
        const label = extractGroupbyLabel({
          datum,
          groupby: groupbyLabels,
          coltypeMapping: {},
        });
        return {
          ...acc,
          [label]: groupbyLabels.map(col => datum[col]),
        };
      },
      {},
    );
  
    const { setDataMask = () => {} } = hooks;

    let seriesMin = 0;
    let seriesMax = 100;
    const seriesData = data.map(datum => {
      const label = extractGroupbyLabel({
        datum,
        groupby: groupbyLabels,
        coltypeMapping: {},
      });
      
      seriesMin = !Number.isNaN(seriesMin) ?
        Math.min(seriesMin, number.numericToNumber(datum[metricLabel]))
        : number.numericToNumber(datum[metricLabel]);
      seriesMax = !Number.isNaN(seriesMax) ?
        Math.max(seriesMax, number.numericToNumber(datum[metricLabel]))
        : number.numericToNumber(datum[metricLabel]);

      return {
        name: label,
        value: datum[metricLabel]
      };
    });
  
    const series: GaugeSeriesOption[] = [
      {
        name: metricLabel,
        type: 'gauge',
        progress: {
          show: true
        },
        detail: {
          // valueAnimation: true,
          // formatter: '{value}',
          show: showLabels
        },
        title: {
          show: showLabels
        },
        // @ts-ignore
        data: seriesData,
        min: seriesMin,
        max: seriesMax
      },
    ];
  
    const echartOptions: EChartsCoreOption = {
      tooltip: {
        formatter: tooltipFormat
      },
      legend: {
        show: showLegend
      },
      series,
    };
  
    return {
      formData,
      width,
      height,
      echartOptions,
      setDataMask,
      labelMap,
      groupby
    };
}
  